import React from "react";

import Avatar, { AvatarSize } from "../../../../components/common/Avatar";
import { UserIdVerifiedIcon } from "../../../../components/common/idVerified";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { IContractProps } from "../../models";
import { ImageTitleAndDescrComp } from "./imageTitleAndDesc";
import { ShowFeedbackAndReview } from "./ShowFeedbackAndReview/ShowFeedbackAndReview";
import styles from "./styles.module.scss";

export const UserInfo = (props: IContractProps) => {
  const { contract } = props;
  const userId = AuthConfig.getUserInfo()?.id;
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const contractUser =
    contract.senderId == userId ? contract.customer : contract.provider;

  const imageNode = () => {
    return (
      <div>
        <div className={styles.avatar_icon_verification}>
          <UserIdVerifiedIcon
            nationalIdVerified={contractUser?.nationalIdVerified}
          />
        </div>
        <Avatar
          alt={contractUser?.profile?.fullName}
          src={contractUser?.profile?.photoUrl}
          avatarSize={AvatarSize.MEDIUM}
        />
      </div>
    );
  };

  const titleNode = () => {
    return (
      <div className={styles.title_wrapper}>
        <p className={"subtitle3"}>
          {contractUser?.profile?.fullName.split(" ")[0]}
        </p>
        <div className={styles.profileRating}>
          {contractUser?.profile.feedbackOverallRatingScore && (
            <>
              <img src="/assets/images/svg/starRatingFill.svg" />{" "}
              <span className={"subtitle1"}>
                {contractUser?.profile?.feedbackOverallRatingScore?.toFixed(1)}
              </span>
            </>
          )}
        </div>
      </div>
    );
  };

  const phoneNumberValueNode = () => {
    return (
      <div dir="ltr" style={{ textAlign: "right" }} className={"p2"}>
        {contractUser?.phoneNumber}
      </div>
    );
  };

  const imageTitleAndDescrComp = () => {
    return (
      <div className={styles.wrapper}>
        <ImageTitleAndDescrComp
          image={imageNode()}
          title={titleNode()}
          value={phoneNumberValueNode()}
        />
      </div>
    );
  };

  return (
    <>
      {contractUser?.id && (
        <ShowFeedbackAndReview
          modalOpen={modalOpen}
          userId={contractUser.id.toString()}
          toggleModal={toggleModal}
        />
      )}
      <span className={styles.mouseClick} onClick={toggleModal}>
        {imageTitleAndDescrComp()}
      </span>
    </>
  );
};
